// extracted by mini-css-extract-plugin
export default {"choice":"styles_choice__qE4aQ","heading":"styles_heading__qlmfe"};